<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">📊</span>
            <span>Palm & Trees Distribution by Area</span>
        </h2>
        <apexchart type="bar" height="400" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
export default {
    name: 'PalmAndTreesByArea',
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: "bar",
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "50%",
                    }
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -45,
                        trim: true,
                        style: {
                            fontSize: "11px"
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "Plant Count"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    position: "top"
                },
                tooltip: {
                    shared: true,
                    intersect: false
                },
                colors: ["#2A9D8F", "#E9C46A"]
            }
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const categories = newData.map(item => item.area);
                const treesData = newData.map(item => this.getCount(item.plants, "Trees"));
                const palmsData = newData.map(item => this.getCount(item.plants, "Palm"));

                this.series = [
                    {
                        name: "Trees",
                        data: treesData,
                    },
                    {
                        name: "Palm",
                        data: palmsData,
                    }
                ];
                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };

            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        getCount(plants, type) {
            const plant = plants.find(p => p.type === type);
            return plant ? plant.total : 0;
        },
    },
};
</script>